"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQuickBuyButtonTooltipHandlers = void 0;
var ProductBoxDisabledQuickBuyClicked = _interopRequireWildcard(require("@ori-events/product-box-disabled-quickbuy-clicked"));
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _useProduct = require("./useProduct");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const useQuickBuyButtonTooltipHandlers = ({
  onClose,
  onToggle,
  open
}) => {
  const {
    code,
    quantityPicker,
    buttons
  } = (0, _useProduct.useProduct)();
  const {
    quickBuy: quickBuyButton
  } = buttons ?? {};
  const onOtherDisabledQuickBuyClick = (0, _react.useCallback)(({
    detail
  }) => {
    if (detail.productCode === code) {
      return;
    }
    onClose();
  }, [code, onClose]);
  const onQuickBuyButtonClick = (0, _react.useCallback)(() => {
    if (quickBuyButton?.disabled && Boolean(quantityPicker?.tooltipMaxText && !open)) {
      window.dispatchEvent(new CustomEvent(ProductBoxDisabledQuickBuyClicked.Name, {
        detail: {
          productCode: code
        }
      }));
    }
    onToggle();
  }, [code, onToggle, open, quantityPicker?.tooltipMaxText, quickBuyButton?.disabled]);
  const events = (0, _react.useMemo)(() => [{
    name: ProductBoxDisabledQuickBuyClicked.Name,
    listener: onOtherDisabledQuickBuyClick
  }], [onOtherDisabledQuickBuyClick]);
  (0, _presentationHooks.useGlobalEvents)(events);
  return {
    onQuickBuyButtonClick
  };
};
exports.useQuickBuyButtonTooltipHandlers = useQuickBuyButtonTooltipHandlers;
